// Get Terms And Conditions

export const GET_TERMS_AND_CONDITIONS_REQUEST =
  'GET_TERMS_AND_CONDITIONS_REQUEST';
export const GET_TERMS_AND_CONDITIONS_SUCCESS =
  'GET_TERMS_AND_CONDITIONS_SUCCESS';
export const GET_TERMS_AND_CONDITIONS_FAIL = 'GET_TERMS_AND_CONDITIONS_FAIL';
export const ADD_TERMS_AND_CONDITIONS = 'ADD_TERMS_AND_CONDITIONS';
export const DELETE_TERMS_AND_CONDITIONS = 'DELETE_TERMS_AND_CONDITIONS';

// Update Terms And Conditions

export const UPDATE_TERMS_AND_CONDITIONS_REQUEST =
  'UPDATE_TERMS_AND_CONDITIONS_REQUEST';
export const UPDATE_TERMS_AND_CONDITIONS_SUCCESS =
  'UPDATE_TERMS_AND_CONDITIONS_SUCCESS';
export const UPDATE_TERMS_AND_CONDITIONS_FAIL =
  'UPDATE_TERMS_AND_CONDITIONS_FAIL';

export const CLEAR_TERMS_AND_CONDITIONS_FAIL =
  'CLEAR_TERMS_AND_CONDITIONS_FAIL';
